<template>
  <b-container fluid="xl" style="max-width:1400px">
    <header class>
      <NavBar style="z-index:20;" :isLight="isLight" v-bind:class="{ 'bg-cream': isLight, 'title-dark':!isLight }" />
    </header>
    <b-row class="align-items-start">
      <transition name="fade" appear>
        
        <b-col
          tag="main"
          cols="12"
          lg="12"
          class="p-0 pt-5"
          style="text-align:center"
          v-bind:class="{ 'bg-white': isLight, 'title-dark':!isLight }"
        >
          <div class="overflow-hidden p-4 p-sm-0 mt-4">
            <slot />
          </div>
        </b-col>
      </transition>
    </b-row>
    <SiteFooter />
  </b-container>
</template>

<script>
import NavBar from "../components/NavBar";
import SiteFooter from '../components/SiteFooter'
export default {
  components: {
    NavBar,
    SiteFooter
  },
  props: {
    isLight: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
.fade-enter-active {
  transition: 0.5s;
}
.bg-cream {
  background: #f4f4f4;
  color: #000;
}
.fade-enter {
  opacity: 0;
}
</style>
